import DesktopTable from "./components/DesctopTable";
import DropdownTableMenu from "./components/DropdownTableMenu";

import { Wrapper } from "./AccordionTable.styled";

const AccordionTable = ({
  data,
  headerData,
  renderRowContent,
  renderDropdownContent,
  renderHeaderTitle,
  showStatus,
  gridSettings,
}) => {
  return (
    <Wrapper>
      <DesktopTable
        data={data}
        headerData={headerData}
        renderRowContent={renderRowContent}
        showStatus={showStatus}
        gridSettings={gridSettings}
      />

      <DropdownTableMenu
        data={data}
        headerData={headerData}
        renderDropdownContent={renderDropdownContent}
        renderHeaderTitle={renderHeaderTitle}
      />
    </Wrapper>
  );
};

export default AccordionTable;
